import { gyromagneticRatio } from 'gyromagnetic-ratio';
import { nucleusSymbolMap } from './nucleusMap';
/**
 * The idea is to convert nucleus name like H1, proton or Fluorine19 to 1H and 19F.
 */
export function normalizeNucleus(name) {
    if (gyromagneticRatio[name]) {
        return name;
    }
    const massNumber = name.replace(/\D/g, '');
    const atomName = name.replace(/\d*\W*/g, '').toLowerCase();
    const nucleusName = atomName.length > 1
        ? nucleusSymbolMap[atomName]
        : atomName.toUpperCase();
    const symbol = `${massNumber}${nucleusName}`;
    if (!gyromagneticRatio[symbol]) {
        throw new Error(`nucleus ${name} is not supported`);
    }
    return symbol;
}
//# sourceMappingURL=normalizeNucleus.js.map